<template>
  <div class="zd-content-page-box">
    <el-table
      v-if="flag"
      ref="multipleTable"
      v-loading="tableLoading"
      :row-style="tableRowStyle"
      :data="tableData"
      :border="isShowBorder"
      :height="tableHeight"
      style="width: 100%"
      :header-cell-class-name="headerCellClassName"
      :header-cell-style="{
        fontSize: '15px',
        fontWeight: '400',
        color: '#303133'
      }"
      :max-height="maxHeight"
      empty-text
      :row-key="rowKey"
      :highlight-current-row="highlightCurrentRow"
      @select-all="handleSelectAll"
      @select="handleSelect"
      @row-click="handleRowClick"
      @selection-change="handleSelectionChange"
      @sort-change="handleSortChange"
    >
      <!-- 无数据提示 v-sticky="{top:0,parent:'#myTableFixed'}" -->
      <div slot="empty" class="empty">
        <img class="slot-empty-img" src="@/assets/tb-empty.png" alt="">
        <p>{{ noData }}</p>
      </div>
      <!-- 勾选框 -->
      <el-table-column
        v-if="selection"
        type="selection"
        :reserve-selection="reserveSelection"
        :width="selectionWidth"
        :fixed="selectionFixed"
        :selectable="selectDisableRoom"
      />
      <template v-for="(item, index) in tableColumns">
        <!-- 操作 -->
        <slot v-if="item.slot" :name="item.slot" />
        <el-table-column
          v-else
          :key="index"
          :prop="item.prop"
          :fixed="fixed"
          :label="item.label"
          :type="item.type"
          :min-width="item.minWidth"
          :width="item.width ? item.width : ''"
          :align="item.align ? item.align : 'left'"
          :sortable="item.sortable ? 'custom' : false"
          :show-overflow-tooltip="item.showTooltip ? item.showTooltip : false"
          :formatter="item.formatter"
        />
      </template>
    </el-table>

    <div
      v-if="(total > 0 && isShowPager) || keepPage"
      class="bottom-pagination"
    >
      <!-- 分页 -->
      <pagination
        v-if="total > 0"
        :samll-button-size="samllButtonSize"
        :pager-count="pagerCount"
        :page-num="page"
        :page-size="rows"
        :total="total"
        :page-sizes="pageSizes"
        @sizeChange="handleSizeChange"
        @currentChange="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import pagination from '@/components/Pagination'
// import { stringify } from 'querystring'
// import { toUnicode } from 'punycode'
export default {
  components: {
    pagination
  },
  props: {
    highlightCurrentRow: {
      type: Boolean,
      default: false
    },
    samllButtonSize: {
      type: Boolean,
      default: () => false
    },
    chooseListTwo: {
      type: Array,
      default: () => []
    },
    border: {
      // 边框
      type: Boolean,
      default: true
    },
    tableData: {
      // 表格数据
      type: Array,
      default: () => {
        return []
      }
    },
    tableColumns: {
      // 表头数据
      type: Array,
      default: () => {
        return []
      }
    },
    tableHeight: {
      // 表格高度
      type: [Number, String],
      default: () => {
        return null
      }
    },
    maxHeight: {
      // 流体高度
      type: Number || String,
      default: () => {
        return null
      }
    },
    selectionFixed: {
      // 列固定
      type: Boolean || String,
      default: () => {
        return false
      }
    },
    fixed: {
      // 列固定
      type: Boolean || String,
      default: () => {
        return false
      }
    },
    selection: {
      // 勾选框
      type: Boolean,
      default: () => {
        return false
      }
    },
    selectionWidth: {
      type: Number || String,
      default: 60
    },
    noData: {
      type: String,
      default: () => {
        return '查找不到相关内容～'
      }
    },
    total: {
      chooseList: {
        type: Array,
        default: () => []
      },
      // 总页数
      type: Number || String,
      default: () => {
        return 0
      }
    },
    page: {
      // 当前页
      type: Number || String,
      default: () => {
        return 1
      }
    },
    rows: {
      // 页码
      type: Number || String,
      default: () => {
        return 10
      }
    },
    tableLoading: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    isShowBorder: {
      type: Boolean,
      default: () => {
        return false // UI基本都是没有边框的
      }
    },
    // eslint-disable-next-line vue/require-default-prop
    formatter: {
      type: Object
    },
    pageSizes: {
      type: Array,
      default: () => {
        return [10, 20, 50, 100]
      }
    },
    // 在数据更新之后保留之前选中的数据
    reserveSelection: {
      type: Boolean,
      default: false
    },
    // row唯一值
    // eslint-disable-next-line vue/require-default-prop
    rowKey: {
      type: Function
    },
    // eslint-disable-next-line vue/require-default-prop
    headerCellClassName: {
      type: [Function, String]
    },
    // 页码按钮的数量
    pagerCount: {
      type: Number,
      default: 7
    },
    // 是否显示页面
    isShowPager: {
      type: Boolean,
      default: true
    },
    keepPage: {
      type: Boolean,
      default: false
    }
    // selectDisableRoom: {
    //   type: Function,
    //   default:()=>{
    //     return
    //   }
    // }
    // isPagination: {
    //   // 是否显示分页
    //   type: Boolean,
    //   default: () => {
    //     return true;
    //   }
    // }
  },
  data() {
    return {
      flag: false,
      selIndex: [],
      state: 1
    }
  },
  watch: {
    tableData: {
      handler() {
        this.flag = true
        this.$nextTick(() => {
          this.$refs.multipleTable && this.$refs.multipleTable.doLayout()
        })
      },
      immediate: true
    }
  },
  mounted() {
    this.state = window.localStorage.getItem('themeColorStyle')
  },
  methods: {
    // goRowSelection(data, val) { // 复选
    //   val.forEach(row => {
    //     let ix = data.findIndex(one => one.tagId === row.tagId)
    //     // if (ix > -1) {
    //       this.$refs.multipleTable.toggleRowSelection(row)
    //     // }
    //   })
    // },
    // 设置表格行的样式
    tableRowStyle({ row, rowIndex }) {
      const arr = this.selIndex || []
      if (arr.length && arr.includes(rowIndex)) {
        return this.$TAB_ROW_ACTIVE
      }
    },

    handelData(val) {
      // eslint-disable-next-line eqeqeq
      if (val == '0') {
        return '0'
      } else if (val) {
        return val
      } else {
        return '--'
      }
    },
    selectDisableRoom(row, index) {
      return !row.select
    },
    // 全选事件
    handleSelectAll(val) {
      this.$emit('handleSelectAll', val)
    },
    // 点击table某一行
    handleRowClick(val) {
      this.$emit('handleRowClick', val)
    },
    // 勾选事件
    handleSelect(selection, row) {
      this.$emit('handleSelect', selection, row)
    },
    // 多选事件
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val)
      // 收集下标
      const ids = val.map((item) => item.id)
      const arr = []
      this.tableData.map((item, index) => {
        for (const i in ids) {
          if (item.id === ids[i]) {
            arr.push(index)
          }
        }
      })
      this.selIndex = arr
    },
    // 排序事件
    handleSortChange(column) {
      this.$emit('handleSortChange', column)
    },
    // 切换当前一页展示多少条
    handleSizeChange(val) {
      console.log(val, 'handleSizeChange')
      this.$emit('handleChange', { pageSize: val, pageNum: 1 })
    },
    // 翻页
    handleCurrentChange(val) {
      console.log(val, 'handleCurrentChange')

      this.$emit('handleChange', { pageNum: val, pageSize: this.rows })
      // 翻页时滚动条回到顶部
      const $ = document.querySelector.bind(document)
      $('.el-table__body-wrapper').scrollTop = 0
    }
  }
}
</script>
<style lang="scss" scoped>
.zd-content-page-box {
  width: 100%;
  background-color: #fff;
  /deep/ .el-table thead {
    color: #909399;
    font-weight: 500;
  }

  /deep/ .el-table--border th,
  .el-table__fixed-right-patch {
    background: rgb(242, 244, 247);
  }
  .empty {
    img {
      height: 150px;
    }
  }
}

/deep/ .el-table__fixed-right {
  border-bottom: 1px solid #ebeef5;
}

/deep/ .el-table__fixed-right::before,
.el-table__fixed::before {
  background-color: #fff;
}
/deep/.el-table__empty-block::after {
  line-height: 52px;
}
//  /deep/.el-tabs {
//     .el-tabs__header {
//       margin-bottom: 14px;
//     }
//     .el-tabs__item span {
//       padding: 0 8px;
//     }
//     .btn-group {
//       display: inline-block;
//     }
//     .is-active {
//       font-weight: bold;
//     }
//   }
.slot-empty-img {
  // height: 100px;
  height: 200px;
  margin-top: 20px;
}

.bottom-pagination {
  margin-right: 20px;
  padding-bottom: 24px;
}
</style>
